import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import Dialog from './Dialog';


class AlertDialog extends Dialog {
    constructor(props){
        super(props);
        
        this.onOk = this.onOk.bind(this);
    }

    show(data){
        
        if(data){
            this.setState({data: data});
        }

        super.show();
    }

    onOk(){
        const {onOk, data} = this.props;
        super.hide();
        onOk(data || this.state.data);
    }

    render(){
        const {submitting, dialogTitle, closeButtonLabel, submitButtonLabel, onOk, message} = this.props;

        return (

        <Modal backdrop="static" keyboard={false} enforceFocus={true} show={this.state.show} onHide={this.hide}>
                <Modal.Header>
                    <Modal.Title>{dialogTitle}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {message}
                </Modal.Body>

                <Modal.Footer>
                    {closeButtonLabel?
                        <Button onClick={this.hide}>{closeButtonLabel}</Button>
                    :
                        ""
                    }
                    <Button onClick={this.onOk}  disabled={submitting}  bsStyle="danger">{submitButtonLabel}</Button>
                </Modal.Footer>

        </Modal>
      
        );
    }
}


AlertDialog.propTypes = {
    dialogTitle: PropTypes.string.isRequired,
    closeButtonLabel: PropTypes.string,
    submitButtonLabel: PropTypes.string.isRequired,
    message: PropTypes.string,
    onOk: PropTypes.func.isRequired
}

export default AlertDialog;



// WEBPACK FOOTER //
// app/components/AlertDialog.jsx